import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { ProductCard } from "../components/ProductCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const categoryFilters = [
  { key: "all", label: "Tutti", className: "bg-white" },
  { key: "magliette", label: "Magliette", className: "bg-accent-yellow" },
  { key: "felpe", label: "Felpe", className: "bg-accent-pink text-white" },
  { key: "homemade", label: "Homemade", className: "bg-accent-green" },
];

const collectionFilters = [
  { key: "all", label: "Tutte", className: "bg-white" },
  { key: "astro", label: "Astro", className: "bg-accent-blue" },
  { key: "drinks", label: "Drinks", className: "bg-accent-pink text-white" },
  { key: "quotes", label: "Quotes", className: "bg-accent-yellow" },
  { key: "handmade", label: "Handmade", className: "bg-accent-green" },
];

export default function AbbigliamentoPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("all");
  const [activeCollection, setActiveCollection] = useState("all");

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        await axios.post(`${API}/seed`);
        const response = await axios.get(`${API}/products`);
        setProducts(response.data);
      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filteredProducts = products.filter((product) => {
    const categoryMatch = activeCategory === "all" || product.category === activeCategory;
    const collectionMatch = activeCollection === "all" || product.collection === activeCollection;
    return categoryMatch && collectionMatch;
  });

  return (
    <div className="min-h-screen bg-white" data-testid="abbigliamento-page">
      <section className="bg-black text-white py-16 border-b-4 border-accent-yellow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="font-heading text-6xl sm:text-7xl mb-4">ABBIGLIAMENTO</h1>
            <p className="font-body text-xl text-gray-300 max-w-2xl">
              Tutti i capi RIKAMI in un unico catalogo: magliette, felpe e prodotti handmade fatti da noi.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="sticky top-20 z-40 bg-white border-b-4 border-black py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex flex-col gap-3">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono text-xs uppercase text-gray-500 mr-1">Categoria</span>
                {categoryFilters.map((filter) => (
                  <button
                    key={filter.key}
                    onClick={() => setActiveCategory(filter.key)}
                    className={`font-mono text-sm uppercase px-4 py-2 border-2 border-black transition-all duration-200 ${
                      activeCategory === filter.key
                        ? `${filter.className} shadow-brutal`
                        : "bg-white hover:bg-gray-100"
                    }`}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono text-xs uppercase text-gray-500 mr-1">Collezione</span>
                {collectionFilters.map((filter) => (
                  <button
                    key={filter.key}
                    onClick={() => setActiveCollection(filter.key)}
                    className={`font-mono text-sm uppercase px-4 py-2 border-2 border-black transition-all duration-200 ${
                      activeCollection === filter.key
                        ? `${filter.className} shadow-brutal`
                        : "bg-white hover:bg-gray-100"
                    }`}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>
            </div>

            <span className="font-mono text-sm text-gray-500">{filteredProducts.length} prodotti</span>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {[...Array(8)].map((_, i) => (
                <div key={i} className="border-2 border-black p-4 animate-pulse">
                  <div className="aspect-square bg-gray-200 mb-4"></div>
                  <div className="h-6 bg-gray-200 mb-2"></div>
                  <div className="h-4 bg-gray-200 w-2/3"></div>
                </div>
              ))}
            </div>
          ) : filteredProducts.length === 0 ? (
            <div className="text-center py-20">
              <p className="font-heading text-3xl mb-4">NESSUN PRODOTTO</p>
              <p className="font-body text-gray-600">Nessun prodotto trovato per questa categoria.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filteredProducts.map((product) => (
                <ProductCard key={product.product_id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
